import template from 'lodash/template';

const ticketTemplate = `CT~~CD,~CC^~CT~
^XA~TA000~JSN^LT0^MNN^MTD^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ
^XA
^MMT
^PW639
^LL{-{-{--}-}-}
^LS0
<% var height = 100; %>
^FO128,<%= (height) %>^GFA,06144,06144,00048,:Z64:
eJztlrFu5UQUho9jRZYSrUyD0mwYK+lCkZYGzXaUvADoPgM9kp2kSJlHICwFkVPkAYK4dytK7haIIAVsoIlSOYIIc+Pr4f/P+DqbbeIUFKA7xdF4/Pvz8ZlzzlhkOZZjOf69kdaxc66VELZ0NLhus5U8z09EaHdo1nK/IGm1CVEjm70+hZlEMHNZ5S0Lo1BXQ+8qw2nG1d/cwlRxv1iPaayuKl/1Yh/wqw3V81at12ahX/BpXvZ8//6J8jm7Un4JfTExBYaMYPY4+51mqosTC1PrzF+TX+qj+zRf9cb7q/69wU8y6umfC2gOaA5d7++E5kafpL4NpNfv9/qv7/mqv+r5rbzFD3v+lPy56n/tv7xZFQno5OkZpC+3tsJT586PMHOVnW1tI2h3+fmX6o9uQkz9JK0lgl6zw3IuQVrZCrf23FQXcY9OlF6PbY6hz3hrzDlfigdD6EvVt3Cb+vc8/0KiIiy67MNcgqIyU/I14mIusU2OmyCAlODvttveH76rTbAIf0LEq0wk6fnZt4IMnCAt4jbq9JzTn5R6vFz9abDyF3IMz0UIwhX4UXvP50tTz1/oBfM26PSlmCZiuEXmFebKv/30o3nHT/+UAPMmaBZ68H36eX/In41PEbTrPOn8OXB1qPw9QCz5Dhin/BBB435yvxvPx7dUEeaxBtm2vogD+kb+sSYR9bV+VOCQOGYGfhEgyOYyQnpfis4Z6ozlMOXihcgIe4ECmZgL8hlkq/6r41qYnl9FHb+SbXdsj7Hn0Ae9//QH/L48F/qUuZRZbj6iwSCn+mnkTzxf9fWCX/KG5XdATyYi0PO1HGRekD/XnuD1zxk86JmZeNNOfkZ+Jl25XedjNIlxz6/WQs5Noxp2lqi51wfuhZh6Q5OKQY7Ajjx/HRrtdLHnO1/J+HDwfVKRz8KomNthkTHC0F+KztlpwgL8iw0tCm5KhH2IiylrR/n0Z7fjt+dOy83Wtr33p0HgyG+Y+eo/EodzppyWs6lNp5+oPqXeNjGZrNNd6jG/0qBJz+emxAi2JrBp+FGqX/An8kzL7cMH/FbmVNna698/PR/Xnu/LwfN5poQ+SQ6c1xvtH4x6JRuuS+nIYaGymg8ocdzo9NjE1jc55xa9pysH30T9S8H/3vt/YTTtGXXwC7kvh5/RRJn/ETYF7d9p/x8zCKHnV+x8WgLtrl7f8zVpyU9rM9cmp3r9lkU5vKnXomC3gJNa3/5x05VAo/6XtvuoBX+ix12jTU4vN7sS8HqlVropyp+/oF5buNZTJrYrAX88SsdvF/zsIV98b2O5ef2G8hHwzn9sdn68cyIreeb/DnZOPF+P91rCh/z2ST8mb41k0NJ/b6xsJQmsTobojfsbtbvBkqmH6B30qN0ZtmCQflT8VPzCBmV4FAzh3zm37dokdXXyuBz/LbfORT8Wvv08Ptr8zLmj/aOs1d/PR/loSpXZlNVXnw+hSzCTqLZH++GrYdnp+SYIXjfD9Mj/ynxxeHAzUF/8EE3NaPTda+eG6FFiR5Udu7s//O/to3znPgY/vb1x/mdlAP/afWOru2F86J8598lm+Vk6iL8+y41rP7BltXM2hB+xqTbPTTmVaBCf+hb6UuJBfCb+dPOdd3GqDeHHsy2bH8dXttzaHcJHYxxlOKPM4bD4Qz/OQnc1PnL+D/txvQG/stET+OvozfEwPrCWhv9yA+Q4GvKdbC2/Pl7LB7Wfp44kSfQcSP4nx8FyLMdyLMdy6PgHbLCkCw==:750E
<% height += 170; %>

^FT75,<%= (height) %>^A0N,20,19^FH\^FD<%= header %>^FS
<% height += 70; %>

^FO25,<%= (height) %>^GB0,67,8^FS
^FO600,<%= (height) %>^GB0,67,8^FS
^FO25,<%= (height) %>^GB580,0,1^FS
<% height += 50; %>
^FT40,<%= (height) %>^A0N,50,30^FH\^FD<%= lang_amount %>:^FS
^FT386,<%= (height) %>^A0N,50,50^FH^FD<%= currency %> <%= amount %>^FS
^FO25,<%= (height +17) %>^GB580,0,1^FS

<% height += 20; %>
<% height += 32; %>
^FT40,<%= (height) %>^A0N,20,16^FH\^FD<%= lang_ticketNumber %>:  <%= ticket_number %>^FS
^FT400,<%= height %>^A0N,20,24^FH\^FD<%= time_stamp %>^FS

<% height += 120%>

^BY3,5^FT200,<%= height %>^B7N,5,0,,,N
^FH\^FD<%= scan_code.toUpperCase() %>^FS
<% height += 25%>
^FT159,<%= height %>^A0N,25,24^FH\^FD<%= scan_code.toUpperCase() %>^FS

<% height += 65; %>
^FT0,<%= (height) %>^A0N,36,30^FB600,1,0,C^FH\^FD<%= lang_warning %> ^FS


<% height += 30; %>
^FT38,<%= (height) %>^A0N,22,22^FH^FD***************************************************^FS
<% height += 30; %>
^FT38,<%= (height) %>^A0N,22,22^FH\^FD<%= footer %>^FS
<% height += 30; %>
^FT38,<%= (height) %>^A0N,22,22^FH^FD***************************************************^FS

<% height += 100%>
{_{_{_<%= height %>_}_}_}
^PQ1,0,1,Y^XZ`;

export function createDepositTicket(ticket_json) {
  const compiled = template(ticketTemplate);
  let d = compiled({
    brand_description: ticket_json.brand_description,
    scan_code: ticket_json.scan_code,
    amount: ticket_json.amount,
    time_stamp: ticket_json.time_stamp,
    ticket_number: ticket_json.ticket_number,
    lang_amount: ticket_json.lang_amount,
    lang_ticketNumber: ticket_json.lang_ticketNumber,
    lang_warning: ticket_json.lang_warning,
    currency: ticket_json.currency,
    header: ticket_json.header ? ticket_json.header.replace(/<br\s*\/?>/gi, ' ') : null,
    footer: ticket_json.header ? ticket_json.footer.replace(/<br\s*\/?>/gi, ' ') : null,
  });

  var heightFinder = /{_{_{_(\d+)_}_}_}/g;
  var match = heightFinder.exec(d);
  if (match != null) {
    var height = match[1];
    d = d.replace(heightFinder, '');
    d = d.replace(/LL{-{-{--}-}-}/g, 'LL' + height);
  }
  return d;
}
